module.exports = __webpack_public_path__ + "static/media/city.ec446ef9.png";